import React from 'react';
import { Helmet } from 'react-helmet-async';

const StructuredData = ({ type = 'Organization', data }) => {
  const getStructuredData = () => {
    switch (type) {
      case 'Organization':
        return {
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: 'Gulf Digital',
          description: 'Leading Value Added Distributor for cybersecurity solutions in the Middle East.',
          url: 'https://gulfdigital-me.com',
          logo: 'https://gulfdigital-me.com/assets/logo.png',
          contactPoint: {
            '@type': 'ContactPoint',
            telephone: '+966554002958',
            contactType: 'Sales',
            email: 'sales@gulfdigital-me.com',
            areaServed: ['ME', 'AF'],
            availableLanguage: ['English', 'Arabic']
          },
          sameAs: [
            'https://www.linkedin.com/company/gulf-digital',
            'https://twitter.com/gulfdigital'
          ],
          ...data
        };

      case 'LocalBusiness':
        return {
          '@context': 'https://schema.org',
          '@type': 'LocalBusiness',
          name: 'Gulf Digital',
          image: 'https://gulfdigital-me.com/assets/logo.png',
          '@id': 'https://gulfdigital-me.com',
          url: 'https://gulfdigital-me.com',
          telephone: '+966554002958',
          email: 'sales@gulfdigital-me.com',
          address: {
            '@type': 'PostalAddress',
            addressCountry: 'SA'
          },
          ...data
        };

      case 'Service':
        return {
          '@context': 'https://schema.org',
          '@type': 'Service',
          serviceType: 'Cybersecurity Services',
          provider: {
            '@type': 'Organization',
            name: 'Gulf Digital'
          },
          areaServed: {
            '@type': 'Place',
            name: 'Middle East'
          },
          ...data
        };

      case 'Product':
        return {
          '@context': 'https://schema.org',
          '@type': 'Product',
          ...data
        };

      case 'BlogPosting':
        return {
          '@context': 'https://schema.org',
          '@type': 'BlogPosting',
          publisher: {
            '@type': 'Organization',
            name: 'Gulf Digital'
          },
          ...data
        };

      default:
        return data;
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(getStructuredData())}
      </script>
    </Helmet>
  );
};

export default StructuredData;